import React from 'react';

const SVG = ({
  style = {},
  fill = '#fff',
  viewBox = '0 0 32 32',
  width = '100%',
  className = '',
  height = '100%',
  ...rest
}) => (
  <svg
    width={width}
    style={style}
    height={height}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox={viewBox}
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...rest}
  >  
    <circle cx="16" cy="16" r="16" fill="#3c3c3c"/>
    <g transform="translate(7.856 7.625)" fill={fill} >
        <path d="M64.239 169.28H61.3c-1.114 0-1.361-.708-1.176-1.287l-.019.058a1.223 1.223 0 0 0 .195 1.049c.508.975 2.1 3.9 2.1 3.9a.979.979 0 0 0 .93.543 6.039 6.039 0 0 0 2.334-.926l5.368-3.339z" transform="translate(-60.058 -156.899)"/>
        <g transform="translate(4.547)">
            <path d="M105.523 72.4a.759.759 0 0 0-.717-.452h-4.677a.751.751 0 0 0-.71.395.744.744 0 0 1 .709-.355h.011a.817.817 0 0 1 .747.54l1.576 3.735 5.205 12.337h4.693z" transform="translate(-99.419 -71.951)"/>
        </g>
        <path d="M65.536 74.63l-4.2 10.005c-.229.62-.082 1.388 1.04 1.388h3.038l3.118-7.376-1.574-3.732c-.1-.23-.253-.712-.775-.712a.663.663 0 0 0-.647.427z" transform="translate(-61.111 -73.943)"/>
    </g>
  </svg>
);
export default SVG;